import { Box } from '@material-ui/core';
import { formatDateTimeReadable, Merchant, MerchantStatus } from '@nemuru-eng/js-api-client';

import { OverviewDetailRow } from '@/components/shared/components/OverviewDetailRow';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { Text } from '@/components/shared/components/Text';
import { StatusTagType } from '@/config/types';

interface MerchantDetailsProps {
  merchant: Merchant;
  showInternalData: boolean;
}

export const MerchantDetails = ({ merchant, showInternalData }: MerchantDetailsProps) => {
  const statusColor = (status: MerchantStatus): StatusTagType => {
    switch (status) {
      case MerchantStatus.STATUS_PENDING_DOCUMENTS:
        return StatusTagType.INFO;
      case MerchantStatus.STATUS_DOCUMENTS_COMPLETED:
      case MerchantStatus.STATUS_PRE_APPROVED:
        return StatusTagType.SUCCESS;
      case MerchantStatus.STATUS_DENIED_PENDING_MANUAL:
      case MerchantStatus.STATUS_DENIED_EVALUATED:
      case MerchantStatus.STATUS_ASLEEP:
        return StatusTagType.WARNING;
      case MerchantStatus.STATUS_SUSPENDED:
      case MerchantStatus.STATUS_BANNED:
        return StatusTagType.ERROR;
    }
  };

  return (
    <Box display={'flex'} flexDirection={'column'}>
      <OverviewDetailRow
        field={
          <>
            <Text tId={'MERCHANT_ID'} />:
          </>
        }
        value={merchant.id}
        copyButton
      />
      <OverviewDetailRow field={<Text tId={'CREATED_AT'} />} value={formatDateTimeReadable(merchant.createdAt)} />
      {showInternalData && (
        <Box pt={2}>
          <StatusTag type={statusColor(merchant.status)} labelTextId={merchant.status} />
        </Box>
      )}
    </Box>
  );
};
